import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { DepositFoldersService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class DepositFolderListBloc extends Bloc<DepositFoldersService['depositFolderControllerGet']> {
    public constructor(service: DepositFoldersService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.depositFolderControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
